import { render, staticRenderFns } from "./studentscore.vue?vue&type=template&id=783c6e4e"
import script from "./studentscore.vue?vue&type=script&lang=js"
export * from "./studentscore.vue?vue&type=script&lang=js"
import style0 from "./studentscore.vue?vue&type=style&index=0&id=783c6e4e&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports